import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    cell: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
        alignItems: 'center'
    },
    btn: {
        height: '50px',
        width: '50px'
    }
}))

export default useStyles